import { Controller } from "@hotwired/stimulus";
import { makeMatcher } from "../utils/text_match";

// Marketplace filtering + sorting on the consultant `selection_intervenants#index`.
//
// Each card encodes its filter payload in `data-card-filter` (JSON):
//   { title, ref, desc, location, reward, start, created }
// Search is accent-insensitive over title/ref/desc/location.
// Sort modes: recent (default, by created desc), reward (desc), upcoming (start asc).
export default class extends Controller {
  static targets = ["search", "sortBtn", "card", "grid", "emptyHint"];

  connect() {
    this.activeSort = "recent";
    this.currentMatcher = makeMatcher("");
    this._refresh();
  }

  search(event) {
    this.currentMatcher = makeMatcher(event.target.value);
    this._refresh();
  }

  switchSort(event) {
    const sort = event.currentTarget.dataset.sort || "recent";
    this.activeSort = sort;
    this.sortBtnTargets.forEach((btn) => {
      btn.classList.toggle("is-active", btn.dataset.sort === sort);
    });
    this._refresh();
  }

  _refresh() {
    if (!this.hasGridTarget) return;

    const visible = this.cardTargets
      .map((card) => ({ card, payload: this._payload(card) }))
      .filter((entry) => this._matches(entry.payload));

    this._sortInPlace(visible);

    // Hide the cards we filter out, show the ones we kept.
    const visibleSet = new Set(visible.map((e) => e.card));
    this.cardTargets.forEach((card) => {
      card.hidden = !visibleSet.has(card);
    });

    // Apply the new order in the grid via DOM reorder.
    visible.forEach(({ card }) => this.gridTarget.appendChild(card));

    if (this.hasEmptyHintTarget) {
      this.emptyHintTarget.hidden = visible.length > 0;
    }
  }

  _matches(payload) {
    // Recherche par mots : chaque mot saisi doit se retrouver quelque part
    // dans titre, référence, description ou lieu, quel que soit son rang.
    return this.currentMatcher(
      `${payload.title || ""} ${payload.ref || ""} ${payload.desc || ""} ${payload.location || ""}`
    );
  }

  _sortInPlace(entries) {
    switch (this.activeSort) {
      case "reward":
        entries.sort((a, b) => (b.payload.reward || 0) - (a.payload.reward || 0));
        break;
      case "upcoming":
        entries.sort((a, b) => (a.payload.start ?? 9999) - (b.payload.start ?? 9999));
        break;
      case "recent":
      default:
        entries.sort((a, b) => (b.payload.created || 0) - (a.payload.created || 0));
        break;
    }
  }

  _payload(card) {
    try { return JSON.parse(card.dataset.cardFilter || "{}"); }
    catch (_e) { return {}; }
  }
}
